/** The references object of all modules needed for components initialization */
var references = {
    'storedetails' : require('_core_ext/pages/storelocator/storedetails'),
};

module.exports = {
    'references' : references
};
